import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { PermissionsService } from '../../services/permissions.service';

export const permissionsGuard: CanActivateFn = (route) => {
  const permSvc  = inject(PermissionsService);
  const router   = inject(Router);
  const optionId = route.data?.['optionId'] as number | number[] | undefined;
  // Una pantalla que se abre desde dos lugares declara las dos opciones: basta con cualquiera.
  const ids = (Array.isArray(optionId) ? optionId : [optionId]).filter((id): id is number => !!id);

  if (!ids.length) return true;

  const check = () => {
    if (permSvc.isSuperAdmin() || ids.some(id => permSvc.canRead(id))) return true;
    return router.createUrlTree(['/acceso-denegado']);
  };

  if (permSvc.isLoaded()) return check();

  return permSvc.loadPermissions().pipe(map(() => check()));
};
